// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__gVQ7z","img":"NotFound_img__IethY","btn":"NotFound_btn__DHYyB"};